export const STEPS = {
  PersonalDetails: 'personal-details',
  Delivery: 'delivery',
  Summary: 'summary',
  Payment: 'payment',
} as const;

export const STORAGE_KEYS = {
  deliveryOption: 'deliveryOption',
  discount: 'discount',
  isValidServiceArea: 'isValidServiceArea',
  enrollmentStatus: 'enrollmentStatus',
  deliveryAppointment: 'deliveryAppointment',
  pickupLocation: 'pickupLocation',
  referrer: 'referrer',
  tempEnrollment: 'tempEnrollment',
  paymentMethod: 'paymentMethod',
} as const;

const allowedReferrers = {
  b2bPartner: 'partner.swapfiets.com',
};
export const allowedReferrerHosts = Object.values(allowedReferrers);
export const BASKET_DELIVERY_REMARKS = 'Member wants a basket';
